var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Designstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-design_store",
    "data-name": "icon-24-design store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7076",
    "data-name": "Rectangle 7076",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(-3.308 -3.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(5.439 12.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M6.787,40.937a1.347,1.347,0,0,1-.953-2.3L16.748,28.273a.231.231,0,0,1,.227-.053l.785.244a.231.231,0,0,1,.152.152l.244.785a.231.231,0,0,1-.053.227L7.743,40.538A1.343,1.343,0,0,1,6.787,40.937ZM16.968,28.7,6.156,38.968a.885.885,0,0,0,0,1.248.908.908,0,0,0,1.253,0L17.675,29.408l-.167-.539Z",
    transform: "translate(-5.439 -28.209)",
    fill: "#02466a",
    stroke: "#02466a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(14.322 5.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M39.217,16.3a.974.974,0,0,1-.158-.013,1,1,0,0,1-.554-.282,1.015,1.015,0,0,1-.25-.411l-.77-2.48-2.478-.77a1,1,0,0,1-.7-.8,1.013,1.013,0,0,1,.413-.98l2.118-1.5L36.81,6.469a1,1,0,0,1,.55-.911,1.029,1.029,0,0,1,1.059.09L40.5,7.2l2.457-.834a1.031,1.031,0,0,1,1.13.408.957.957,0,0,1,.147.87L43.4,10.1l1.552,2.079a1.008,1.008,0,0,1-.81,1.61h0l-2.606-.033-1.5,2.118A1.008,1.008,0,0,1,39.217,16.3ZM37.817,5.91a.546.546,0,0,0-.545.553l.034,2.715a.231.231,0,0,1-.1.191l-2.217,1.569a.549.549,0,0,0-.224.53.542.542,0,0,0,.377.436l2.594.806a.231.231,0,0,1,.152.152l.806,2.594a.554.554,0,0,0,.136.224.545.545,0,0,0,.83-.071l1.569-2.217a.225.225,0,0,1,.191-.1l2.716.035h0a.546.546,0,0,0,.444-.873l-1.625-2.176a.231.231,0,0,1-.034-.212L43.8,7.5a.5.5,0,0,0-.085-.453.56.56,0,0,0-.607-.239l-2.572.872a.232.232,0,0,1-.212-.034L38.144,6.019A.547.547,0,0,0,37.817,5.91Z",
    transform: "translate(-34.299 -5.452)",
    fill: "#fff",
    stroke: "#02466a",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Designstore);
export default __webpack_public_path__ + "static/media/icon-24-design store.706d2bcd75f9c404e6f4a6a54a4e3fa2.svg";
export { ForwardRef as ReactComponent };